import { gql } from "@apollo/client";

export const GET_TRADE_CONTEXT = gql`
  query GetTradeContext($tradeId: Int!) {
    getTradeContext(tradeId: $tradeId) {
      trade {
        id
        symbol
        side
        notes
        date
        walletId
        positions {
          id
          type
          quantity
          price
          date
        }
      }
      priceAtEntry {
        price
        timestamp
      }
      priceAtExit {
        price
        timestamp
      }
      currentPrice {
        price
        timestamp
        volume
        provider
      }
      priceComparison {
        entryPrice
        currentPrice
        priceChange
        priceChangePercent
        pnlImpact {
          unrealizedPnl
          pnlPercent
          totalPositionValue
          totalEntryValue
          isProfitable
        }
      }
      pnlImpact {
        unrealizedPnl
        pnlPercent
        totalPositionValue
        totalEntryValue
        isProfitable
      }
      marketConditions {
        volatility
        volume
        rsi
        movingAverage
        support
        resistance
        timestamp
        marketSentiment
      }
      whatIfScenarios {
        scenario
        entryPrice
        exitPrice
        entryTime
        exitTime
        pnl
        pnlPercent
        description
        isOptimal
      }
    }
  }
`;
